import { ModulesStorage } from './connectors/ModulesStorage';
import { IModulesStorageStrong } from './interfaces/IModulesStorage';

/**
 * Internal modules storage
 * @singleton
 */
export const internalModules: IModulesStorageStrong = new ModulesStorage();
